module.exports = {
          srcSet: __webpack_public_path__ + "4e1f093abfb51f2ad8294db398ba408b-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "4e1f093abfb51f2ad8294db398ba408b-180.png",width: 180,height: 12}],
          src: __webpack_public_path__ + "4e1f093abfb51f2ad8294db398ba408b-180.png",
          toString:function(){return __webpack_public_path__ + "4e1f093abfb51f2ad8294db398ba408b-180.png"},
          
          width: 180,
          height: 12
        }